export default __webpack_public_path__ + "static/media/selecta_big.9f660c41.jpg";